import { DiscountTileSkeleton, Repeat, Skeleton } from '@boss/ui';

const DiscountsSkeleton = () => (
  <div className="flex flex-col gap-7">
    {/* Section 1: Default Discounts (Standaardkorting) — 3 amount variants */}
    <div>
      <Skeleton className="mb-5 h-6 w-40" />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        <Repeat amount={3}>
          <DiscountTileSkeleton variant="amount" />
        </Repeat>
      </div>
    </div>

    {/* Section 2: Specific Discounts (Specifieke kortingen) — 3 link variants */}
    <div>
      <Skeleton className="mb-5 h-6 w-40" />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        <Repeat amount={3}>
          <DiscountTileSkeleton variant="link" />
        </Repeat>
      </div>
    </div>

    {/* Section 3: Worksite Discounts (Werfkorting) — 1 link variant */}
    <div>
      <Skeleton className="mb-5 h-6 w-40" />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        <Repeat amount={1}>
          <DiscountTileSkeleton variant="link" />
        </Repeat>
      </div>
    </div>
  </div>
);

export default DiscountsSkeleton;
